module.exports = __webpack_public_path__ + "static/media/utility_pole_concrete.212c9447.png";